<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>

<script>

import {getAction} from "@api/manage";

export default {
  name: 'app',
  beforeCreate() {
    getAction("/front/home/getConfig").then(res => {
      if(res.success){
        this.$store.commit('setConfig', res.result);
        this.$initMeta(res.result.title,res.result.keyword,res.result.desc)
      }
    })

   getAction("/front/mallManufacturer/getList").then(res => {
     if(res.success){
       this.$store.commit('setManufacturerList', res.result);
     }
   })

  },
  beforeMount() {

  },
  beforeRouteEnter(to, from, next){
    next();
  }
}
</script>

<style>
.main{
  font-family:  Poppins-SemiBold,Microsoft YaHei, Helvetica Neue, Helvetica, sans-serif;
//font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: var(--main-text-color);
}
.lodding-box{
  background-color: white;
}
</style>
